// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3txsZ","productName":"Table_productName__5kT4f"};